import { GridComparatorFn, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid-pro';
import moment from 'moment';
import { DATE_FORMAT_DEFAULT_NO_TIME, DATE_FORMAT_DEFAULT } from '../../../../appConstants';
import { compareDate } from '../../../../services/helper/functionHelper';

export default class CustomTableHelper {
    public static CustomGridDateOperator : Array<GridFilterOperator> = [
        {
            label: 'Is',
            value: 'is',
            InputComponentProps: { type: 'date' },
            getApplyFilterFn: (filterItem : GridFilterItem) => {
                if (!filterItem.field || !filterItem.value || !filterItem.operator) {
                    return null;
                }
          
                return (params) : boolean => {
                    const rowValue = moment(params.value, DATE_FORMAT_DEFAULT_NO_TIME);
                    const filterValue = moment(filterItem.value, DATE_FORMAT_DEFAULT_NO_TIME);

                    return rowValue.isSame(filterValue);
                };
            },
        },
        {
            label: 'Is Not',
            value: 'isNot',
            InputComponentProps: { type: 'date' },
            getApplyFilterFn: (filterItem : GridFilterItem) => {
                if (!filterItem.field || !filterItem.value || !filterItem.operator) {
                    return null;
                }
          
                return (params) : boolean => {
                    const rowValue = moment(params.value, DATE_FORMAT_DEFAULT_NO_TIME);
                    const filterValue = moment(filterItem.value, DATE_FORMAT_DEFAULT_NO_TIME);

                    return !rowValue.isSame(filterValue);
                };
            },
        },
        {
            label: 'Is Before',
            value: 'isBefore',
            InputComponentProps: { type: 'date' },
            getApplyFilterFn: (filterItem : GridFilterItem) => {
                if (!filterItem.field || !filterItem.value || !filterItem.operator) {
                    return null;
                }
          
                return (params) : boolean => {
                    const rowValue = moment(params.value, DATE_FORMAT_DEFAULT_NO_TIME);
                    const filterValue = moment(filterItem.value, DATE_FORMAT_DEFAULT_NO_TIME);

                    const result = rowValue.isBefore(filterValue);

                    return result;
                };
            },
        },
        {
            label: 'Is On or Before',
            value: 'isOnOrBefore',
            InputComponentProps: { type: 'date' },
            getApplyFilterFn: (filterItem : GridFilterItem) => {
                if (!filterItem.field || !filterItem.value || !filterItem.operator) {
                    return null;
                }
          
                return (params) : boolean => {
                    const rowValue = moment(params.value, DATE_FORMAT_DEFAULT_NO_TIME);
                    const filterValue = moment(filterItem.value, DATE_FORMAT_DEFAULT_NO_TIME);

                    const result = rowValue.isSameOrBefore(filterValue);

                    return result;
                };
            },
        },
        {
            label: 'Is After',
            value: 'isAfter',
            InputComponentProps: { type: 'date' },
            getApplyFilterFn: (filterItem : GridFilterItem) => {
                if (!filterItem.field || !filterItem.value || !filterItem.operator) {
                    return null;
                }
          
                return (params) : boolean => {
                    const rowValue = moment(params.value, DATE_FORMAT_DEFAULT_NO_TIME);
                    const filterValue = moment(filterItem.value, DATE_FORMAT_DEFAULT_NO_TIME);

                    const result = rowValue.isAfter(filterValue);

                    return result;
                };
            },
        },
        {
            label: 'Is On or After',
            value: 'isOnOrAfter',
            InputComponentProps: { type: 'date' },
            getApplyFilterFn: (filterItem : GridFilterItem) => {
                if (!filterItem.field || !filterItem.value || !filterItem.operator) {
                    return null;
                }
          
                return (params) : boolean => {
                    const rowValue = moment(params.value, DATE_FORMAT_DEFAULT_NO_TIME);
                    const filterValue = moment(filterItem.value, DATE_FORMAT_DEFAULT_NO_TIME);

                    const result = rowValue.isSameOrAfter(filterValue);

                    return result;
                };
            },
        },
        {
            label: 'Is Empty',
            value: 'isEmpty',
            InputComponentProps: { type: 'date' },
            getApplyFilterFn: () => {
                return (params) : boolean => {
                    return !params.value;
                };
            },
        },
        {
            label: 'Is Not Empty',
            value: 'isNotEmpty',
            InputComponentProps: { type: 'date' },
            getApplyFilterFn: () => {
                return (params) : boolean => {
                    return !!params.value;
                };
            },
        },
    ];

    public static CustomGridDateSorter : GridComparatorFn<string> = (dateStringA : string, dateStringB : string) => {
        // Note that by not applying the format twice the result will be "Invalid Date".
        const dateA = moment(dateStringA, DATE_FORMAT_DEFAULT).format(DATE_FORMAT_DEFAULT);
        const dateB = moment(dateStringB, DATE_FORMAT_DEFAULT).format(DATE_FORMAT_DEFAULT);

        return compareDate(dateA, dateB);
    };
}